import { message } from 'antd';

export function copyToClipboard(value: string, name: string) {
    navigator.clipboard.writeText(value || '');
    message.info(`${name} کپی شد`);
}
